export const GET_SALES_EVENT_TYPES_REQUESTED = 'GET_SALES_EVENT_TYPES_REQUESTED'
export const GET_SALES_EVENT_TYPES_SUCCEEDED = 'GET_SALES_EVENT_TYPES_SUCCEEDED'
export const GET_SALES_EVENT_TYPES_FAILED = 'GET_SALES_EVENT_TYPES_FAILED'
